import React from 'react';

function Input({ type, value, name, onChange, label, className }) {
  return (
    <>
      <label htmlFor={name}>{label}</label>
      <input
        // required
        type={type}
        value={value}
        name={name}
        onChange={onChange}
        className={className}
        placeholder={label ? label.toLowerCase().slice(0, -1) : null}
      />
    </>
  );
}

export default Input;
